import { getComposeStore } from '../selectors/getComposeStore';
import type {
    ComposeViewState,
    FullComposeViewState,
    QuickComposeViewState,
    MetricsInfo,
    AttachmentFiles,
} from 'owa-calendar-compose-types';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    ComposeFormType,
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';

export function getComposeViewState(formId: string | null): ComposeViewState | null {
    const viewState = getComposeStore(formId).uiState;

    return viewState ? (viewState as ComposeViewState) : null;
}

export function getFullComposeViewState(formId: string | null): FullComposeViewState | null {
    if (getOpenedForm(formId) == FULL_COMPOSE_FORM_TYPE) {
        const viewState = getComposeViewState(formId);

        if (viewState) {
            return viewState as FullComposeViewState;
        }
    }

    return null;
}

export function getQuickComposeViewState(formId: string | null): QuickComposeViewState | null {
    if (getOpenedForm(formId) == QUICK_COMPOSE_FORM_TYPE) {
        const viewState = getComposeViewState(formId);

        if (viewState) {
            return viewState as QuickComposeViewState;
        }
    }

    return null;
}

export function getOriginalEvent(formId: string | null): CalendarEvent | null {
    return getComposeStore(formId).originalEvent;
}

export function getComposeEvent(formId: string | null): CalendarEvent | null {
    return getComposeStore(formId).event;
}

export function getOpenedForm(formId: string | null): ComposeFormType | null {
    return getComposeStore(formId).openedForm;
}

export function getMetricsInfo(formId: string | null): MetricsInfo | null {
    return getComposeStore(formId).metricsInfo;
}

export function getAttachmentFiles(formId: string | null): AttachmentFiles | null {
    return getComposeStore(formId).attachmentFiles;
}
